module.exports = __webpack_public_path__ + "img/BaliBody1.36844be2.jpg";